!(function(root, factory) {
    "use strict";
    "function" == typeof define && define.amd
        ? define(["mediator-js"], function(Mediator) {
              return (root.analyticstracker = factory(Mediator, window));
          })
        : "object" == typeof exports
        ? (module.exports = factory(require("mediator-js").Mediator, window))
        : (root.analyticstracker = factory(root.Mediator, window));
})(this, function(Mediator, window) {
    "use strict";
    var _instance,
        document = window.document,
        navigator = window.navigator,
        HTMLSelector = function HTMLSelector(selectorSettings) {
            if (!(this instanceof HTMLSelector)) return new HTMLSelector();
            (this.eventSelector = selectorSettings.hasOwnProperty(
                "eventSelector",
            )
                ? selectorSettings.eventSelector
                : "data-tracking-event"),
                (this.infoSelector = selectorSettings.hasOwnProperty(
                    "infoSelector",
                )
                    ? selectorSettings.infoSelector
                    : "data-tracking-info"),
                (this.commerceSelector = selectorSettings.hasOwnProperty(
                    "commerceSelector",
                )
                    ? selectorSettings.commerceSelector
                    : "data-tracking-commerce"),
                (this.pageSelector = selectorSettings.hasOwnProperty(
                    "pageSelector",
                )
                    ? selectorSettings.pageSelector
                    : "page-impression"),
                (this.doneSelector = selectorSettings.hasOwnProperty(
                    "doneSelector",
                )
                    ? selectorSettings.doneSelector
                    : "data-tracking-done"),
                (this.extendPageInfo = selectorSettings.hasOwnProperty(
                    "extendPageInfo",
                )
                    ? selectorSettings.extendPageInfo
                    : [
                          "url",
                          "userAgent",
                          "platform",
                          "domain",
                          "referrer",
                          "title",
                          "path",
                          "timestamp",
                          "params",
                          "consent",
                      ]),
                (this.formSubmitSelector = selectorSettings.hasOwnProperty(
                    "formSubmitSelector",
                )
                    ? selectorSettings.formSubmitSelector
                    : "form-submit"),
                (this.iframeSelector = selectorSettings.hasOwnProperty(
                    "iframeSelector",
                )
                    ? selectorSettings.iframeSelector
                    : "iframe-impression"),
                (this.consentCookie = "cookieconsent"),
                (this.disableVisibilityCheck = !1);
        };
    (HTMLSelector.prototype._splitUri = function(uri) {
        var split,
            splitRegExp = new RegExp(
                "^(?:([^:/?#.]+):)?(?://(?:([^/?#]*)@)?([\\w\\d\\-\\u0100-\\uffff.%]*)(?::([0-9]+))?)?([^?#]+)?(?:\\?([^#]*))?(?:#(.*))?$",
            );
        return (
            (split = uri.match(splitRegExp)),
            {
                protocol: split[1],
                user_info: split[2],
                domain: split[3],
                port: split[4],
                pathname: split[5],
                search: split[6],
                hash: split[7],
            }
        );
    }),
        (HTMLSelector.prototype.setPageInfoField = function(info, field) {
            function pad(n) {
                return n < 10 ? "0" + n : n;
            }
            var overWriteUrl = !!info.url && this._splitUri(info.url);
            switch (field) {
                case "url":
                    info.url = !1 !== overWriteUrl ? info.url : document.URL;
                    break;
                case "domain":
                    info.domain =
                        !1 !== overWriteUrl
                            ? overWriteUrl.domain
                            : document.domain;
                    break;
                case "referrer":
                    info.referrer = document.referrer;
                    break;
                case "title":
                    info.title = document.title;
                    break;
                case "userAgent":
                    info.userAgent = navigator.userAgent;
                    break;
                case "platform":
                    info.platform = navigator.platform;
                    break;
                case "path":
                    info.path =
                        !1 !== overWriteUrl
                            ? overWriteUrl.pathname
                            : document.location.pathname;
                    break;
                case "hash":
                    document.location.hash
                        ? (info.hash = document.location.hash)
                        : (info.hash =
                              !1 !== overWriteUrl ? overWriteUrl.hash : "");
                    break;
                case "timestamp":
                    var d = new Date();
                    info.timestamp =
                        d.getFullYear() +
                        "-" +
                        pad(d.getMonth() + 1) +
                        "-" +
                        pad(d.getDate()) +
                        " " +
                        pad(d.getHours()) +
                        ":" +
                        pad(d.getMinutes()) +
                        ":" +
                        pad(d.getSeconds());
                    break;
                case "params":
                    (info.params = {}),
                        document.location.search
                            ? document.location.search.replace(
                                  /[?&]+([^=&]+)=([^&]*)/gi,
                                  function(str, key, value) {
                                      info.params[key] = decodeURIComponent(
                                          value,
                                      );
                                  },
                              )
                            : !1 !== overWriteUrl &&
                              overWriteUrl.search &&
                              overWriteUrl.search.replace(
                                  /([^&=]+)=?([^&]*)(?:&+|$)/g,
                                  function(match, key, value) {
                                      info.params[key] = decodeURIComponent(
                                          value,
                                      );
                                  },
                              );
                    break;
                case "consent":
                    info.consent = this._getConsentLevelFromCookie();
            }
            return info;
        }),
        (HTMLSelector.prototype.isVisible = function(elem) {
            if (this.disableVisibilityCheck) return !0;
            var style = getComputedStyle(elem);
            if ("none" === style.display) return !1;
            if ("visible" !== style.visibility) return !1;
            if (style.opacity < 0.1) return !1;
            if (
                elem.offsetWidth +
                    elem.offsetHeight +
                    elem.getBoundingClientRect().height +
                    elem.getBoundingClientRect().width ===
                0
            )
                return !1;
            var elemCenter = {
                x: elem.getBoundingClientRect().left + elem.offsetWidth / 2,
                y: elem.getBoundingClientRect().top + elem.offsetHeight / 2,
            };
            if (elemCenter.x < 0) return !1;
            if (
                elemCenter.x >
                (document.documentElement.clientWidth || window.innerWidth)
            )
                return !1;
            if (elemCenter.y < 0) return !1;
            if (
                elemCenter.y >
                (document.documentElement.clientHeight || window.innerHeight)
            )
                return !1;
            var pointContainer = document.elementFromPoint(
                elemCenter.x,
                elemCenter.y,
            );
            do {
                if (pointContainer === elem) return !0;
            } while ((pointContainer = pointContainer.parentNode));
            return !1;
        }),
        (HTMLSelector.prototype._selectElements = function(selector) {
            return document.querySelectorAll(selector);
        }),
        (HTMLSelector.prototype._getItemType = function(item) {
            var event = item.getAttribute(this.eventSelector);
            return event == this.pageSelector
                ? "page-impression"
                : event.match(/impression/g)
                ? "impression"
                : "interaction";
        }),
        (HTMLSelector.prototype._getFormFieldData = function(formItem) {
            switch (formItem.tagName) {
                case "INPUT":
                    return !formItem.hasAttribute("type") ||
                        ("radio" != formItem.getAttribute("type") &&
                            "checkbox" != formItem.getAttribute("type"))
                        ? formItem.value
                        : formItem.checked
                        ? formItem.value
                        : "";
                case "TEXTAREA":
                case "SELECT":
                    return formItem.value;
            }
        }),
        (HTMLSelector.prototype._inArray = function(item, collectList) {
            for (var i = 0, ilen = collectList.length; i < ilen; i++)
                if (item == collectList[i]) return !0;
            return !1;
        }),
        (HTMLSelector.prototype._getFormData = function(item, collectList) {
            var formData = {};
            if ("FORM" == item.tagName) {
                for (
                    var formElements = item.elements,
                        j = 0,
                        jlen = formElements.length;
                    j < jlen;
                    j++
                ) {
                    var formItem = formElements[j];
                    if (formItem.hasAttribute(this.infoSelector)) {
                        var fieldName = JSON.parse(
                            formItem.getAttribute(this.infoSelector),
                        ).field;
                        (this._inArray("all", collectList) ||
                            this._inArray(fieldName, collectList)) &&
                            ((formData[fieldName] = formData[fieldName] || ""),
                            (formData[fieldName] +=
                                "" == this._getFormFieldData(formItem)
                                    ? ""
                                    : this._getFormFieldData(formItem) + ","));
                    }
                }
                for (var anItem in formData)
                    formData.hasOwnProperty(anItem) &&
                        (formData[anItem] = formData[anItem].slice(0, -1));
            } else {
                fieldName = JSON.parse(item.getAttribute(this.infoSelector))
                    .field;
                (this._inArray("all", collectList) ||
                    this._inArray(fieldName, collectList)) &&
                    (formData[fieldName] = this._getFormFieldData(item));
            }
            return formData;
        }),
        (HTMLSelector.prototype._getCookie = function(cookiename) {
            for (
                var name = cookiename + "=",
                    ca = document.cookie.split(";"),
                    i = 0;
                i < ca.length;
                i++
            ) {
                for (var c = ca[i]; " " == c.charAt(0); ) c = c.substring(1);
                if (0 == c.indexOf(name)) {
                    return c.substring(name.length, c.length);
                }
            }
            return !1;
        }),
        (HTMLSelector.prototype._getConsentLevelFromCookie = function() {
            return this._getCookie(this.consentCookie);
        });
    var analyticstracker = function analyticstracker() {
        if (!(this instanceof analyticstracker)) return new analyticstracker();
        (this.mediator = new Mediator()),
            (this._trackingSubscribers = []),
            (this._internalTrackingQueue = []),
            (this._internalTrackingHistory = []),
            (this._htmlSelector = new HTMLSelector({})),
            (this._errorList = []),
            (this._eventList = []),
            (this._consent = this._htmlSelector._getConsentLevelFromCookie()),
            (this._version = "1.0.2"),
            (this.pageInfo = null);
    };
    return (
        (analyticstracker.prototype.getInstance = function() {
            return _instance || (_instance = analyticstracker()), _instance;
        }),
        (analyticstracker.prototype.setHTMLSelectors = function(
            selectorSettings,
        ) {
            this._htmlSelector = new HTMLSelector(selectorSettings);
        }),
        (analyticstracker.prototype.resetTracker = function() {
            (this._internalTrackingQueue = []),
                (this._internalTrackingHistory = []),
                (this._errorList = []),
                (this._eventList = []),
                (this._consent = this._htmlSelector._getConsentLevelFromCookie()),
                (this.pageInfo = null);
        }),
        (analyticstracker.prototype.getConsent = function() {
            return (
                (this._consent = this._htmlSelector._getConsentLevelFromCookie()),
                this._consent
            );
        }),
        (analyticstracker.prototype.clone = function(a) {
            return JSON.parse(JSON.stringify(a));
        }),
        (analyticstracker.prototype.subscribe = function(
            subscribername,
            callback,
        ) {
            return (
                "function" == typeof callback &&
                    (this._runHistory(subscribername, callback),
                    this._trackingSubscribers.push({
                        name: subscribername,
                        subscriber: this.mediator.subscribe(
                            "tracking",
                            callback,
                        ),
                    })),
                !1
            );
        }),
        (analyticstracker.prototype._runHistory = function(
            subscribername,
            callback,
        ) {
            if (0 != this._internalTrackingHistory.length) {
                for (
                    var subscriber = this.mediator.subscribe(
                            "tracking_history",
                            callback,
                            {
                                predicate: function(eventname, data, id) {
                                    return id === subscriber.id;
                                },
                            },
                        ),
                        i = 0,
                        len = this._internalTrackingHistory.length;
                    i < len;
                    i++
                ) {
                    var item = this._internalTrackingHistory[i];
                    this.mediator.publish(
                        "tracking_history",
                        item.event,
                        item,
                        subscriber.id,
                    );
                }
                this.mediator.remove("tracking_history", subscriber.id);
            }
        }),
        (analyticstracker.prototype._runQueue = function() {
            for (
                var i = 0, len = this._internalTrackingQueue.length;
                i < len;
                i++
            ) {
                var item = this._internalTrackingQueue.shift();
                null == item.pageInfo && (item.pageInfo = this.pageInfo),
                    this.mediator.publish("tracking", item.event, item),
                    this._internalTrackingHistory.push(item);
            }
        }),
        (analyticstracker.prototype._track = function(trackEventData) {
            var eventdata = this.clone(trackEventData),
                preEmptiveQueue = !1;
            if (
                (eventdata.event == this._htmlSelector.pageSelector
                    ? ((this.pageInfo = this.clone(eventdata.info)),
                      delete eventdata.info)
                    : (preEmptiveQueue = !0),
                null == this.pageInfo)
            )
                return this._internalTrackingQueue.push(eventdata), !1;
            (eventdata.pageInfo = this.pageInfo),
                preEmptiveQueue && this._runQueue(),
                this.mediator.publish("tracking", eventdata.event, eventdata),
                this._internalTrackingHistory.push(eventdata),
                preEmptiveQueue || this._runQueue();
        }),
        (analyticstracker.prototype._isObject = function(obj) {
            return null !== obj && "object" == typeof obj;
        }),
        (analyticstracker.prototype._isPlainObject = function(obj) {
            return (
                this._isObject(obj) &&
                (obj.constructor === Object || void 0 === obj.constructor)
            );
        }),
        (analyticstracker.prototype._mergeDeep = function(target, sources) {
            if (
                (Array.isArray(sources) || (sources = [sources]),
                !sources.length)
            )
                return target;
            var source = sources.shift();
            if (Array.isArray(target))
                if (Array.isArray(source))
                    for (var i = 0, len = source.length; i < len; i++)
                        target.push(source[i]);
                else target.push(source);
            else if (this._isPlainObject(target)) {
                if (!this._isPlainObject(source))
                    throw new Error("Cannot merge object with non-object");
                for (var key in source)
                    source.hasOwnProperty(key) &&
                        (target[key]
                            ? this._mergeDeep(target[key], source[key])
                            : (target[key] = source[key]));
            } else target = source;
            return this._mergeDeep(target, sources);
        }),
        (analyticstracker.prototype.getErrors = function() {
            return this._errorList;
        }),
        (analyticstracker.prototype.getEventFromElement = function(
            theElements,
        ) {
            for (
                var theEvent = "", i = 0, len = theElements.length;
                i < len;
                i++
            ) {
                var item = theElements[i];
                if (item.hasAttribute(this._htmlSelector.eventSelector))
                    return (theEvent = item.getAttribute(
                        this._htmlSelector.eventSelector,
                    ));
            }
            return theEvent;
        }),
        (analyticstracker.prototype.trackElement = function(
            theElements,
            options,
        ) {
            try {
                var collector = [];
                void 0 === options && (options = null);
                var addData =
                        null !== options && options.hasOwnProperty("addData")
                            ? options.addData
                            : null,
                    checkVisibility =
                        null === options ||
                        !options.hasOwnProperty("checkVisibility") ||
                        options.checkVisibility,
                    doCollect =
                        !(
                            null === options ||
                            !options.hasOwnProperty("doCollect")
                        ) && options.doCollect,
                    extendPageInfo =
                        null === options ||
                        !options.hasOwnProperty("extendPageInfo") ||
                        options.extendPageInfo,
                    changeEvent =
                        null !== options &&
                        options.hasOwnProperty("changeEvent")
                            ? options.changeEvent
                            : null,
                    newPage =
                        !(
                            null === options ||
                            !options.hasOwnProperty("newPage")
                        ) && options.newPage,
                    collectFormData =
                        !(
                            null === options ||
                            !options.hasOwnProperty("collectFormData")
                        ) && options.collectFormData;
                if (newPage)
                    for (
                        var elements = this._htmlSelector._selectElements(
                                "[" +
                                    this._htmlSelector.eventSelector +
                                    "$=-impression]",
                            ),
                            i = 0,
                            len = elements.length;
                        i < len;
                        i++
                    ) {
                        var item = elements[i];
                        "impression" == this._htmlSelector._getItemType(item) &&
                            item.removeAttribute(
                                this._htmlSelector.doneSelector,
                            );
                    }
                for (i = 0, len = theElements.length; i < len; i++) {
                    item = theElements[i];
                    if (
                        !checkVisibility ||
                        "impression" != this._htmlSelector._getItemType(item) ||
                        this._htmlSelector.isVisible(item)
                    ) {
                        var eventElement = {
                            event:
                                null === changeEvent
                                    ? item.getAttribute(
                                          this._htmlSelector.eventSelector,
                                      )
                                    : changeEvent,
                        };
                        if (
                            !eventElement.event.match(/impression/g) ||
                            eventElement.event ==
                                this._htmlSelector.pageSelector ||
                            !item.getAttribute(this._htmlSelector.doneSelector)
                        ) {
                            if (
                                (item.getAttribute(
                                    this._htmlSelector.infoSelector,
                                ) &&
                                    (eventElement.info = JSON.parse(
                                        item.getAttribute(
                                            this._htmlSelector.infoSelector,
                                        ),
                                    )),
                                item.getAttribute(
                                    this._htmlSelector.commerceSelector,
                                ) &&
                                    (eventElement.commerce = JSON.parse(
                                        item.getAttribute(
                                            this._htmlSelector.commerceSelector,
                                        ),
                                    )),
                                eventElement.event ==
                                    this._htmlSelector.pageSelector &&
                                    extendPageInfo &&
                                    this._htmlSelector.extendPageInfo.length >
                                        0)
                            )
                                for (
                                    var k = 0,
                                        klen = this._htmlSelector.extendPageInfo
                                            .length;
                                    k < klen;
                                    k++
                                ) {
                                    var infoField = this._htmlSelector
                                        .extendPageInfo[k];
                                    eventElement.info.hasOwnProperty(
                                        infoField,
                                    ) ||
                                        (eventElement.info = this._htmlSelector.setPageInfoField(
                                            eventElement.info,
                                            infoField,
                                        ));
                                }
                            if (
                                (null !== addData &&
                                    (eventElement = this._mergeDeep(
                                        eventElement,
                                        addData,
                                    )),
                                !1 !== collectFormData)
                            ) {
                                var formData = {
                                    info: {
                                        formdata: this._htmlSelector._getFormData(
                                            item,
                                            collectFormData,
                                        ),
                                    },
                                };
                                eventElement = this._mergeDeep(
                                    eventElement,
                                    formData,
                                );
                            }
                            doCollect
                                ? collector.push(eventElement)
                                : this._track(eventElement),
                                "impression" ==
                                    this._htmlSelector._getItemType(item) &&
                                    item.setAttribute(
                                        this._htmlSelector.doneSelector,
                                        "true",
                                    );
                        }
                    }
                }
                if (doCollect && collector.length > 0) {
                    var collectedEvent = {
                            event: collector[0].event,
                            info: [],
                            commerce: [],
                        },
                        n = 0;
                    for (len = collector.length; n < len; n++) {
                        (item = collector.shift()).info &&
                            collectedEvent.info.push(item.info),
                            item.commerce &&
                                collectedEvent.commerce.push(item.commerce);
                    }
                    0 == collectedEvent.info.length &&
                        delete collectedEvent.info,
                        0 == collectedEvent.commerce.length &&
                            delete collectedEvent.commerce,
                        this._track(collectedEvent);
                }
            } catch (e) {
                return this._errorList.push(e), !1;
            }
            return !0;
        }),
        (analyticstracker.prototype.getVisibleImpressions = function(
            eventSelector,
        ) {
            try {
                var selector =
                        "[" +
                        this._htmlSelector.eventSelector +
                        '="' +
                        eventSelector +
                        '"]:not([' +
                        this._htmlSelector.doneSelector +
                        '="true"])',
                    selectedElements = this._htmlSelector._selectElements(
                        selector,
                    ),
                    visibleElements = [];
                if (selectedElements.length)
                    for (
                        var i = 0, len = selectedElements.length;
                        i < len;
                        i++
                    ) {
                        var item = selectedElements[i];
                        "impression" == this._htmlSelector._getItemType(item) &&
                            this._htmlSelector.isVisible(item) &&
                            visibleElements.push(item);
                    }
            } catch (e) {
                return this._errorList.push(e), !1;
            }
            return visibleElements;
        }),
        (analyticstracker.prototype.isVisibleItem = function(selector) {
            try {
                var selectedElements = this._htmlSelector._selectElements(
                    selector,
                );
                if (selectedElements.length) {
                    var item = selectedElements[0];
                    if (this._htmlSelector.isVisible(item)) return !0;
                }
            } catch (e) {
                return this._errorList.push(e), !1;
            }
            return !1;
        }),
        (analyticstracker.prototype.trackImpression = function(
            eventSelector,
            options,
        ) {
            try {
                var selector =
                        "[" +
                        this._htmlSelector.eventSelector +
                        '="' +
                        eventSelector +
                        '"]:not([' +
                        this._htmlSelector.doneSelector +
                        '="true"])',
                    selectedElements = this._htmlSelector._selectElements(
                        selector,
                    );
                selectedElements.length &&
                    this.trackElement(selectedElements, options);
            } catch (e) {
                return this._errorList.push(e), !1;
            }
            return !0;
        }),
        (analyticstracker.prototype.trackEvent = function(eventData) {
            return this._track(eventData), !0;
        }),
        (analyticstracker.prototype.trackInteraction = function(
            event,
            options,
        ) {
            return _instance.trackElement([event.currentTarget], options);
        }),
        (analyticstracker.prototype.trackIFrames = function(iframeURLs) {
            if (!Array.isArray(iframeURLs)) throw new Error("Array expected");
            window.addEventListener(
                "message",
                function(event) {
                    if (iframeURLs.indexOf(event.origin) > -1) {
                        var ev = JSON.parse(event.data);
                        _instance.trackEvent(ev);
                    }
                },
                !1,
            );
        }),
        (analyticstracker.prototype.register = function(eventList) {
            this._eventList = eventList;
        }),
        (analyticstracker.prototype.trackingSubscribe =
            analyticstracker.prototype.subscribe),
        analyticstracker.prototype.getInstance
    );
});
